import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { AccessNotGrantedComponent } from './components/access-not-granted/access-not-granted.component';
import { LoadingGroupedComponent } from './components/loading-grouped/loading-grouped.component';
import { CustomHeaderComponent } from './components/header/components/custom-header/custom-header.component';
import { GalapagosproComponent } from './components/header/components/custom-header/templates/galapagospro/galapagospro.component';
import { GalavailComponent } from './components/header/components/custom-header/templates/galavail/galavail.component';
import { FourworldstravelsComponent } from './components/header/components/custom-header/templates/fourworldstravels/fourworldstravels.component';
import { GalapagosdeComponent } from './components/header/components/custom-header/templates/galapagosde/galapagosde.component';
import { FusiontravelecuadorComponent } from './components/header/components/custom-header/templates/fusiontravelecuador/fusiontravelecuador.component';
import { GloballandtourComponent } from './components/header/components/custom-header/templates/globallandtour/globallandtour.component';
import { GalapagosinsidersComponent } from './components/header/components/custom-header/templates/galapagosinsiders/galapagosinsiders.component';
import { HakuadventureComponent } from './components/header/components/custom-header/templates/hakuadventure/hakuadventure.component';
import { AdventurejourneysComponent } from './components/header/components/custom-header/templates/adventurejourneys/adventurejourneys.component';
import { MytriptoecuadorComponent } from './components/header/components/custom-header/templates/mytriptoecuador/mytriptoecuador.component';
import { CamiadventuresComponent } from './components/header/components/custom-header/templates/camiadventures/camiadventures.component';
import { EcuatravelingComponent } from './components/header/components/custom-header/templates/ecuatraveling/ecuatraveling.component';
import { QuitobiketoursComponent } from './components/header/components/custom-header/templates/quitobiketours/quitobiketours.component';
import { GalatrailsComponent } from './components/header/components/custom-header/templates/galatrails/galatrails.component';
import { QuitotourbusComponent } from './components/header/components/custom-header/templates/quitotourbus/quitotourbus.component';
import { NaturegalapagosComponent } from './components/header/components/custom-header/templates/naturegalapagos/naturegalapagos.component';
import { QuichuanativetravelComponent } from './components/header/components/custom-header/templates/quichuanativetravel/quichuanativetravel.component';
import { ImagineecuadorComponent } from './components/header/components/custom-header/templates/imagineecuador/imagineecuador.component';
import { GalapagoslastminutesComponent } from './components/header/components/custom-header/templates/galapagoslastminutes/galapagoslastminutes.component';
import { SurtrekComponent } from './components/header/components/custom-header/templates/surtrek/surtrek.component';
import { EquatorexpeditionsComponent } from './components/header/components/custom-header/templates/equatorexpeditions/equatorexpeditions.component';
import { EcuadorfamilytoursComponent } from './components/header/components/custom-header/templates/ecuadorfamilytours/ecuadorfamilytours.component';
import { CarpedmComponent } from './components/header/components/custom-header/templates/carpedm/carpedm.component';
import { GulliverexpeditionsComponent } from './components/header/components/custom-header/templates/gulliverexpeditions/gulliverexpeditions.component';
import { WhastappButtonComponent } from './components/whastapp-button/whastapp-button.component';
import { AntarcticbookingcenterComponent } from './components/header/components/custom-header/templates/antarcticbookingcenter/antarcticbookingcenter.component';
import { TakiritravelComponent } from './components/header/components/custom-header/templates/takiritravel/takiritravel.component';
import { ColumbustravelecuadorComponent } from './components/header/components/custom-header/templates/columbustravelecuador/columbustravelecuador.component';
import { GalapagosluxurycruisesComponent } from './components/header/components/custom-header/templates/galapagosluxurycruises/galapagosluxurycruises.component';
import { DiscoverygalapagosComponent } from './components/header/components/custom-header/templates/discoverygalapagos/discoverygalapagos.component';
import { EcuadortierradefuegoComponent } from './components/header/components/custom-header/templates/ecuadortierradefuego/ecuadortierradefuego.component';
import { HandmadetravelComponent } from './components/header/components/custom-header/templates/handmadetravel/handmadetravel.component';
import { VolcanicparadisegalapagosComponent } from './components/header/components/custom-header/templates/volcanicparadisegalapagos/volcanicparadisegalapagos.component';
import { LatamretreatsComponent } from './components/header/components/custom-header/templates/latamretreats/latamretreats.component';
import { GalapagosdreamsComponent } from './components/header/components/custom-header/templates/galapagosdreams/galapagosdreams.component';
import { MidlandtravelComponent } from './components/header/components/custom-header/templates/midlandtravel/midlandtravel.component';
import { LinkexperiencesComponent } from './components/header/components/custom-header/templates/linkexperiences/linkexperiences.component';
import { ScubaiguanaComponent } from './components/header/components/custom-header/templates/scubaiguana/scubaiguana.component';
import { GalaappComponent } from './components/header/components/custom-header/templates/galaapp/galaapp.component';
import { GalapagosedenComponent } from './components/header/components/custom-header/templates/galapagoseden/galapagoseden.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ServiceUnavailableComponent } from './components/service-unavailable/service-unavailable.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SharedModule } from '../shared/shared.module';
import { GalapagosdestinytoursComponent } from './components/header/components/custom-header/templates/galapagosdestinytours/galapagosdestinytours.component';
import { LuxuryprivatejourneysComponent } from './components/header/components/custom-header/templates/luxuryprivatejourneys/luxuryprivatejourneys.component';
import { PapayatoursComponent } from './components/header/components/custom-header/templates/papayatours/papayatours.component';
import { RebeccaadventuretravelComponent } from './components/header/components/custom-header/templates/rebeccaadventuretravel/rebeccaadventuretravel.component';
import { GettravelgalapagosComponent } from './components/header/components/custom-header/templates/gettravelgalapagos/gettravelgalapagos.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        HeaderComponent,
        FooterComponent,
        LoadingComponent,
        AccessNotGrantedComponent,
        LoadingGroupedComponent,
        WhastappButtonComponent,
        CustomHeaderComponent,
        GalapagosproComponent,
        GalavailComponent,
        FourworldstravelsComponent,
        GalapagosdeComponent,
        FusiontravelecuadorComponent,
        GloballandtourComponent,
        GalapagosinsidersComponent,
        HakuadventureComponent,
        AdventurejourneysComponent,
        MytriptoecuadorComponent,
        CamiadventuresComponent,
        EcuatravelingComponent,
        QuitobiketoursComponent,
        GalatrailsComponent,
        QuitotourbusComponent,
        NaturegalapagosComponent,
        QuichuanativetravelComponent,
        ImagineecuadorComponent,
        GalapagoslastminutesComponent,
        SurtrekComponent,
        EquatorexpeditionsComponent,
        EcuadorfamilytoursComponent,
        CarpedmComponent,
        GulliverexpeditionsComponent,
        AntarcticbookingcenterComponent,
        TakiritravelComponent,
        ColumbustravelecuadorComponent,
        GalapagosluxurycruisesComponent,
        DiscoverygalapagosComponent,
        EcuadortierradefuegoComponent,
        HandmadetravelComponent,
        VolcanicparadisegalapagosComponent,
        LatamretreatsComponent,
        GalapagosdreamsComponent,
        MidlandtravelComponent,
        LinkexperiencesComponent,
        ScubaiguanaComponent,
        GalaappComponent,
        GalapagosedenComponent,
        NotFoundComponent,
        ServiceUnavailableComponent,
        LogoutComponent,
        GalapagosdestinytoursComponent,
        LuxuryprivatejourneysComponent,
        PapayatoursComponent,
        RebeccaadventuretravelComponent,
        GettravelgalapagosComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        LoadingComponent,
        LoadingGroupedComponent,
        WhastappButtonComponent,
        LogoutComponent
    ]
})
export class CoreModule { }
